export default "__VITE_ASSET__BbueF0cv__"